module.exports = __webpack_public_path__ + "img/img3.ea448f74.svg";